import { render, staticRenderFns } from "./showUserTasks.vue?vue&type=template&id=1a921b65&"
import script from "./showUserTasks.vue?vue&type=script&lang=js&"
export * from "./showUserTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports